var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEyeshape = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.779 41.152c-.024-.035-2.824-3.615-7.365-7.218-2.637-2.086-5.32-3.756-7.98-4.951-3.37-1.518-6.71-2.285-9.926-2.285-3.217 0-6.557.767-9.926 2.285-2.66 1.201-5.343 2.865-7.98 4.95-4.54 3.599-7.342 7.184-7.365 7.22a1.16 1.16 0 0 0 .023 1.394c.118.146 2.883 3.65 7.348 7.19 2.636 2.085 5.32 3.75 7.98 4.95 3.363 1.518 6.703 2.285 9.92 2.285 3.216 0 6.556-.767 9.92-2.285 2.66-1.195 5.343-2.865 7.98-4.95 4.465-3.54 7.23-7.044 7.347-7.19a1.16 1.16 0 0 0 .024-1.395ZM25.073 47.95a48.44 48.44 0 0 1-6.399-6.117 48.152 48.152 0 0 1 6.405-6.123 40.398 40.398 0 0 1 4.341-3 15.025 15.025 0 0 0-3.052 9.123c0 3.34 1.072 6.51 3.052 9.123a39.156 39.156 0 0 1-4.347-3.006Zm16.435 6.709c-7.072 0-12.826-5.754-12.826-12.826 0-7.072 5.754-12.826 12.826-12.826 7.072 0 12.826 5.754 12.826 12.826 0 7.072-5.754 12.826-12.826 12.826Zm16.435-6.709a39.137 39.137 0 0 1-4.348 3.006 15.025 15.025 0 0 0 3.053-9.123c0-3.34-1.072-6.51-3.053-9.123a39.83 39.83 0 0 1 4.342 3 48.156 48.156 0 0 1 6.404 6.123 48.432 48.432 0 0 1-6.398 6.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.289 40.291a3.07 3.07 0 0 1-1.647-5.66 7.858 7.858 0 1 0 4.728 7.207c0-1.014-.193-1.98-.544-2.871a3.076 3.076 0 0 1-2.531 1.33l-.006-.006Z"
  }))));
};
export { SvgEyeshape as ReactComponent };